import Parser from "./parser";
import saveAs from "file-saver";
import ExcelJS from "../node_modules/exceljs/dist/es5/exceljs.browser";

const TableToExcel = (function(Parser) {
  let methods = {};

  methods.initWorkBook = function() {
    let wb = new ExcelJS.Workbook();
    return wb;
  };

  methods.initSheet = function(wb, sheetName, isRtl) {
    let ws = wb.addWorksheet(sheetName);
    ws.views = [
      {rightToLeft: isRtl}
    ]
    return ws;
  };

  methods.save = function(wb, fileName) {
    wb.xlsx.writeBuffer().then(function(buffer) {
      saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        fileName
      );
    });
  };

  methods.tableToSheet = function(wb, table, opts, imgOpts) {
    let ws = this.initSheet(wb, opts.sheet.name, opts.sheet.rtl);
    ws = Parser.parseDomToTable(ws, table, opts);
    var myBase64Image = imgOpts.base64Img;
    var imageId1 = wb.addImage({ 
      base64: myBase64Image,
      extension: 'png',
   });
   ws.addImage(imageId1, {
    tl: { col: imgOpts.col, row: imgOpts.row },
    ext: { width: imgOpts.width, height: imgOpts.height }
  });
    return wb;
  };

  methods.tableToBook = function(table, opts, imgOpts) {
    let wb = this.initWorkBook();
    wb = this.tableToSheet(wb, table, opts, imgOpts);
    return wb;
  };

  methods.convert = function(table, opts = {}, imgOpts) {
    let defaultOpts = {
      name: "export.xlsx",
      autoStyle: false,
      sheet: {
        name: "Sheet 1",
        rtl: false
      }
    };
    opts = { ...defaultOpts, ...opts };
    let wb = this.tableToBook(table, opts, imgOpts);
    this.save(wb, opts.name);
  };

  return methods;
})(Parser);

export default TableToExcel;
window.TableToExcel = TableToExcel;
